<template>
	<div class="mealConfirmBtn">
		<div class="confirmBtn" v-if="btnText" :style="enable" @click.stop="showConfirm">
			{{ btnText }}
			<div class="count" v-if="count > 0">{{ count }}</div>
		</div>
		<template v-else>
			<div class="numContainer" v-if="count">
				<div class="btn sub" @click.stop="updateCart('sub')">-</div>
				<div class="num">{{ count }}</div>
				<div class="btn plus" v-if="count >= meal.storage || (meal.is_must && count > 0)" :style="enable" @click.stop="showMsg">+</div>
				<div class="btn plus" v-else @click.stop="updateCart('plus')">+</div>
				
			</div>
			<img src="@/assets/images/plus.png" v-else class="plus" :style="enable" @click.stop="updateCart('addMeal')" />
			
		</template>
	</div>
</template>
<script>
import {
	StoreMealObject,
	SelectedStoreDetail,

} from '@/constants';
import $localStorage from '@/utils/localStorage';
import { instance as Toast } from '@/plugins/toast/';
export default {
	props: {
		meal: {
			type: Object,
			default: () => ({})
		},
		property: {
			type: Array,
			default: []
		},
		parter: {
			type: Array,
			default: []
		},
		shopOptions: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			storeDetail: {},
			mealObj: {},
      baskets: [],
			disable: 'display:inline;',
			enable: ''
		};
	},
	computed: {
		btnText() {
			let arr = [];
			if (this.parter.length > 0) {
				arr.push('搭配');
			}
			if (this.property.length > 0) {
				arr.push('属性');
			}

			return arr.length > 0 ? '选' + arr.join('/') : '';
		},
		count() {
			let count = 0;
      this.baskets = $localStorage.get(`baskets_${this.shopOptions.store_id}`) || [];

      this.baskets.forEach(basket => {
        if( basket && basket.mealList) {
          let mealList = basket.mealList;

          mealList.filter(meal => meal.meal_id == this.meal.id)
                  .map(meal => count += meal.amount)
        }
      });
			return count;
		}
	},
	mounted() {
		this.$root.$on('updateStorage', this.updateStorage);
		this.updateStorage();
	},
	updated() {
		let count = this.count;
		let meal = this.$props.meal;
		if (count >= meal.storage || (meal.is_must && count > 0)) {
			this.disable = 'display:none; pointer-events: none;background-color:#a6a6a6;';
			this.enable = "background-color:#a6a6a6;";
		} else {
			this.disable = 'display:inline;';
			this.enable = "";
		}
	},
	methods: {
		showConfirm() {
			let count = this.count;
			let meal = this.$props.meal;
			if (count >= meal.storage || (meal.is_must && count > 0)) {
				this.$msgbox.show({
					messageText: '必选品仅限选择一次！',
					confirmBtnText: '我知道了'
				});
				return false;
			}
			else
			{
				this.$emit('showConfirm', this.meal);
			}
		},
		showMsg() {
			let count = this.count;
			let meal = this.$props.meal;
			if (count >= meal.storage || (meal.is_must && count > 0)) {
				this.$msgbox.show({
					messageText: '必选品仅限选择一次！',
					confirmBtnText: '我知道了'
				});
				return false;
			}
		},
		updateCart(type) {
			this.$emit('submit', type, {
				checkedProperty: [],
				checkedPropertyIds: '',
				checkedParter: [],
				checkedParterIds: '',
				checkedParterProperty: [],
				checkedParterPropertyIds: '',
				meal: this.meal,
				amount: type == 'sub' ? this.count : 1,
				meal_id: this.meal.id,
				price: parseFloat(this.meal.price),
				rebate_price: parseFloat(this.meal.rebate_price),
				hasDiscount: !!(this.meal.rebate_price && this.meal.rebate_price != '0.00' && this.meal.rebate_price != this.meal.price),
				discount: parseFloat(this.meal.price) - parseFloat(this.meal.rebate_price),
				parterPropertyPrice: 0,
				category: this.meal.backup_id
			});
		},
		updateStorage() {
			this.storeDetail = $localStorage.get(SelectedStoreDetail) || {};
      this.baskets = $localStorage.get(`baskets_${this.shopOptions.store_id}`) || [];
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/libs.scss';
.mealConfirmBtn {
	@include pos-a(auto, 20, 20, auto);
	.confirmBtn {
		padding: 0 px2rem(10);
		border-radius: px2rem(10);
		background-color: $shallowCyan;
		font-size: px2rem(26);
		line-height: px2rem(36);
		color: white;
		.count {
			@include pos-a(-20, -10);
			@include square(30);
			border-radius: 100%;
			text-align: center;
			line-height: px2rem(30);
			background-color: #e32351;
			color: white;
			font-size: px2rem(20);
		}
	}
	.plus {
		display: block;
		@include square(40);
	}
	.numContainer {
		@include dis-flex(center);
		height: px2rem(40);
		.btn {
			@include square(40);
			text-align: center;
			font-size: px2rem(30);
			line-height: px2rem(36);
			font-weight: bold;
			border-radius: 100%;
			&.plus {
				background-color: #72c6c8;
				color: white;
			}
			&.sub {
				color: #a6a6a6;
				border: px2rem(1) solid #a6a6a6;
			}
			&.disabled {
				background-color: #a6a6a6;
				pointer-events: none;
			}
		}
		.num {
			font-size: px2rem(28);
			color: #545b5b;
			margin: 0 px2rem(20);
		}
	}
}
</style>
